import { StyleRules } from '@material-ui/core/styles';
import { LinkClassKey } from '@material-ui/core/Link';

import { core as theme } from '../styles/core';

export const MuiLink: Partial<StyleRules<LinkClassKey>> = {
  root: {
    '&:hover': {
      color: (props: { color: string }) =>
        props.color &&
        (props.color === 'primary' ||
          props.color === 'secondary' ||
          props.color === 'error')
          ? theme.palette[props.color].dark
          : 'inherit',
    },
  },
};
